module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('span', {
    attrs: {
      "id": "logo"
    }
  }, [_vm._v("√1Ⓡи$")]), _vm._v(" "), _c('h1', [_vm._v("Virus: The Game")]), _vm._v(" "), _c('router-view', {
    attrs: {
      "id": "content"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46514b18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 84
// module chunks = 1